import AgroleasingLogo from '@/assets/images/services/Agroleasing_V1.png'
import OdnoklassnikiLogo from '@/assets/images/services/Odnoklassniki_V1.png'
import AregakLogo from '@/assets/images/services/aregak_v1.png'
import ArmatisLogo from '@/assets/images/services/armatis_v1.png'
import AvanHillsLogo from '@/assets/images/services/avan_hills_v1.png'
import BlessUcoLogo from '@/assets/images/services/bless_uco_v1.png'
import CardAgroCreditLogo from '@/assets/images/services/card_agro_credit_v1.png'
import CondominiumLogo from '@/assets/images/services/condominium.png'
import Condominium2020Logo from '@/assets/images/services/condominium_2020_v1.png'
import CredoFinanceLogo from '@/assets/images/services/credo_finance_v1.png'
import CrossoutLogo from '@/assets/images/services/crossout_V1.png'
import EmexRuLogo from '@/assets/images/services/emex_ru_v1.png'
import EnaLogo from '@/assets/images/services/ena.png'
import FamilyNetworkLogo from '@/assets/images/services/family_network_v1.png'
import FarmCreditLogo from '@/assets/images/services/farm_credit_v1.png'
import FastnetLogo from '@/assets/images/services/fastnet_v1.png'
import FincaLogo from '@/assets/images/services/finca_v1.png'
import FirstMortgageLogo from '@/assets/images/services/first_mortgage_v1.png'
import FullnetLogo from '@/assets/images/services/fullnet_v1.png'
import GazpromLogo from '@/assets/images/services/gazprom.png'
import GlobalCreditLogo from '@/assets/images/services/global_credit_v1.png'
import GlobbingLogo from '@/assets/images/services/globbing_v1.png'
import GlovoLogo from '@/assets/images/services/glovo_v1.png'
import GoodCreditLogo from '@/assets/images/services/good_credit_v1.png'
import Gyurjyan1Logo from '@/assets/images/services/gyurjyan_1_v1.png'
import HeroesWmLogo from '@/assets/images/services/heroeswm_v1.png'
import HnetLogo from '@/assets/images/services/hnet_v1.png'
import IrrigationLogo from '@/assets/images/services/irigation.png'
import KamurjLogo from '@/assets/images/services/kamurj_uco_credit_v1.png'
import LikenetLogo from '@/assets/images/services/like_net_v1.png'
import MamikonyantsLogo from '@/assets/images/services/mamikonyants_v1.png'
import MimoBikeLogo from '@/assets/images/services/mimo_bike_v1.png'
import VivaMtsLogo from '@/assets/images/services/mts.png'
import NorNorkLogo from '@/assets/images/services/nor_nork_v1.png'
import NorashenLogo from '@/assets/images/services/norashen_6_v1.png'
import NoravanLogo from '@/assets/images/services/noravan_v1.png'
import NormanCreditLogo from '@/assets/images/services/norman_credit_v1.png'
import OnexLogo from '@/assets/images/services/onex_v1.png'
import OvioLogo from '@/assets/images/services/ovio.png'
import RealtimeLogo from '@/assets/images/services/realtime_v1.png'
import SmartCreditLogo from '@/assets/images/services/smart_credit_v1.png'
import SteamLogo from '@/assets/images/services/steam_V1.png'
import StroyMasterLogo from '@/assets/images/services/stroy_master_v1.png'
import TeamTelecomLogo from '@/assets/images/services/team-telecom.png'
import TeamEnergyLogo from '@/assets/images/services/team_energy.png'
import TeampayLogo from '@/assets/images/services/teampay.png'
import TsaravAghbyurLogo from '@/assets/images/services/tsarav_aghbyur_V1.png'
import UbpayLogo from '@/assets/images/services/ubpay.png'
import UcomLogo from '@/assets/images/services/ucom.png'
import VTelecomLogo from '@/assets/images/services/v_telecom_v1.png'
import VarksAmLogo from '@/assets/images/services/varks_am_v1.png'
import VeoliaLogo from '@/assets/images/services/veolia.png'
import VisusTvLogo from '@/assets/images/services/visus_tv_v1.png'
import WarfaceLogo from '@/assets/images/services/warface_V1.png'
import YerevanRideLogo from '@/assets/images/services/yerevan_ride_v1.png'
import YotaLogo from '@/assets/images/services/yota_v1.png'
import { CameraIcon } from '@/components/icons/CameraIcon'
import { CarIcon } from '@/components/icons/CardIcon'
import { CreditCardIcon } from '@/components/icons/CreditCardIcon'
import { ElectricityIcon } from '@/components/icons/ElectricityIcon'
import { FixedPhoneIcon } from '@/components/icons/FixedPhoneIcon'
import { GamepadIcon } from '@/components/icons/GamepadIcon'
import { GarbageIcon } from '@/components/icons/GarbageIcon'
import { GasIcon } from '@/components/icons/GasIcon'
import { GlobeIcon } from '@/components/icons/GlobeIcon'
import { GovernmentIcon } from '@/components/icons/GovernmentIcon'
import { HomeIcon } from '@/components/icons/HomeIcon'
import { MobilePhoneIcon } from '@/components/icons/MobilePhoneIcon'
import { ParkingIcon } from '@/components/icons/ParkingIcon'
import { PercentIcon } from '@/components/icons/PercentIcon'
import { PolicemanIcon } from '@/components/icons/PolicemanIcon'
import { PropertyIcon } from '@/components/icons/PropertyIcon'
import { ServicesIcon } from '@/components/icons/ServicesIcon'
import { TeamPayIcon } from '@/components/icons/TeamPayIcon'
import { WaterIcon } from '@/components/icons/WaterIcon'
import { WifiIcon } from '@/components/icons/WifiIcon'

import { TCategoryTab } from '../types'

export const CATEGORY_TABS: TCategoryTab[] = [
  {
    id: 'utilities',
    title: 'categories.options.utilities.short',
    types: [
      {
        name: 'categories.options.utilities.types.mobile',
        icon: <MobilePhoneIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.teamTelecom',
            img: TeamTelecomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.vivaCell',
            img: VivaMtsLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.ucom',
            img: UcomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.fixed',
        icon: <FixedPhoneIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.teamTelecom',
            img: TeamTelecomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.ucom',
            img: UcomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.ovio',
            img: OvioLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.internetAndTv',
        icon: <WifiIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.teamTelecom',
            img: TeamTelecomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.ucom',
            img: UcomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.ovio',
            img: OvioLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.fastnet',
            img: FastnetLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.fnetTelecom',
            img: FamilyNetworkLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.fullnet',
            img: FullnetLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.hnetTelecom',
            img: HnetLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.likenet',
            img: LikenetLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '4,000 - 100,000'
          },
          {
            name: 'providers.realtime',
            img: RealtimeLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.vTelecom',
            img: VTelecomLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.visusTv',
            img: VisusTvLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.yota',
            img: YotaLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.gas',
        icon: <GasIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.gazprom',
            img: GazpromLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.gazpromService',
            img: GazpromLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.electricity',
        icon: <ElectricityIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.ena',
            img: EnaLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.teamEnergy',
            img: TeamEnergyLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.enaTransmission',
            img: EnaLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.enaTechConnection',
            img: EnaLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.water',
        icon: <WaterIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.veolia',
            img: VeoliaLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.irrigationService',
            img: IrrigationLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.irrigationConsumption',
            img: IrrigationLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.intercom',
        icon: <HomeIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.armatis',
            img: ArmatisLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.stroyMaster',
            img: StroyMasterLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.fnetIntercom',
            img: FamilyNetworkLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          }
        ]
      },
      {
        name: 'categories.options.utilities.types.condominium',
        icon: <GovernmentIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.adontsPremium',
            img: CondominiumLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.avan2',
            img: CondominiumLogo,
            commission: ['categories.commission.commission300AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,700'
          },
          {
            name: 'providers.avan5',
            img: CondominiumLogo,
            commission: ['categories.commission.commission300AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,700'
          },
          {
            name: 'providers.tsaravAghbyur',
            img: TsaravAghbyurLogo,
            commission: ['categories.commission.commission200AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,800'
          },
          {
            name: 'providers.norashen6',
            img: NorashenLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.noravan',
            img: NoravanLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.norNork',
            img: NorNorkLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.veratsnund',
            img: CondominiumLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.avanHillsCondominium',
            img: AvanHillsLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.mamikonyantsCondominium',
            img: MamikonyantsLogo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.condominium2020',
            img: Condominium2020Logo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.gyurjyan1',
            img: Gyurjyan1Logo,
            commission: ['categories.commission.commissionCondominiumTiered'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          }
        ]
      }
    ]
  },
  {
    id: 'financial',
    title: 'categories.options.financial.short',
    types: [
      {
        name: 'categories.options.financial.types.teampay',
        icon: <TeamPayIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.teampay',
            img: TeampayLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 399.999'
          }
        ]
      },
      {
        name: 'categories.options.financial.types.card',
        icon: <CreditCardIcon size="20px" className="text-primary-500" />,
        providerColumnTitle: 'categories.transferType.title',
        providers: [
          {
            name: 'providers.linkedCardToBankCard',
            img: null,
            commission: ['categories.commission.commission08Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.linkedCardToDigitalCard',
            img: null,
            commission: ['categories.commission.commission03Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.walletToDigitalOrLinkedCard',
            img: null,
            commission: ['categories.commission.commission08Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          },
          {
            name: 'providers.digitalCardToDigitalCard',
            img: null,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 390,000'
          }
        ]
      },
      {
        name: 'categories.options.financial.types.fastTransfers',
        icon: <GlobeIcon size="20px" className="text-primary-500" />,
        notes: [
          'categories.notes.fastTransfersCommission',
          'categories.notes.fastTransfersLimit'
        ],
        providers: [
          {
            name: 'providers.ubpay',
            img: UbpayLogo,
            commission: ['categories.commission.commissionZeroFootnote'],
            period: 'categories.transferPeriod.minutes',
            available: ['branches'],
            maxSum: '1,000 - 5,000,000',
            maxSumNote: '**'
          }
        ]
      },
      // {
      //   name: 'categories.options.financial.types.bankAccount',
      //   icon: <BankIcon size="20px" className="text-primary-500" />,
      //   providers: [
      //     {
      //       name: 'providers.conversebank',
      //       img: ConverseLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.byblosbank',
      //       img: ByblosLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.ardshinbank',
      //       img: ArdshinLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.unibank',
      //       img: UnibankLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.evocabank',
      //       img: EvocabankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.fastbank',
      //       img: FastBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.acbabank',
      //       img: AcbaBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.armeconombank',
      //       img: AEBLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.ameriabank',
      //       img: AmeriaBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.idbank',
      //       img: IDBankLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.araratbank',
      //       img: AraratBankLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.inecobank',
      //       img: InecoBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.amiobank',
      //       img: AmioBankLogo,
      //       commission: ['categories.commission.commissionAmio'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.armswissbank',
      //       img: ArmswissBankLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.vtbbank',
      //       img: VTBLogo,
      //       commission: ['categories.commission.commissionVTBAccount'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.artsakhbank',
      //       img: ArtsakhBankLogo,
      //       commission: ['categories.commission.commissionArtsakhBank'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     }
      //   ]
      // },
      {
        name: 'categories.options.financial.types.loanUco',
        icon: <PercentIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.firstMortgage',
            img: FirstMortgageLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '1,000 - 99,500'
          },
          {
            name: 'providers.aregak',
            img: AregakLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.cardAgroCredit',
            img: CardAgroCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.finca',
            img: FincaLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.globalCredit',
            img: GlobalCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.goodCredit',
            img: GoodCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.kamurj',
            img: KamurjLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.varksAm',
            img: VarksAmLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.smartCredit',
            img: SmartCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.credoFinance',
            img: CredoFinanceLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.blessUco',
            img: BlessUcoLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.agroleasingCredit',
            img: AgroleasingLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.farmCredit',
            img: FarmCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          },
          {
            name: 'providers.normanCredit',
            img: NormanCreditLogo,
            commission: ['categories.commission.commission500AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 99,500'
          }
        ]
      }
      // {
      //   name: 'categories.options.financial.types.loan',
      //   icon: <PercentIcon size="20px" className="text-primary-500" />,
      //   providers: [
      //     {
      //       name: 'providers.conversebank',
      //       img: ConverseLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.byblosbank',
      //       img: ByblosLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.ardshinbank',
      //       img: ArdshinLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.unibank',
      //       img: UnibankLogo,
      //       commission: ['categories.commission.commission400AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.evocabank',
      //       img: EvocabankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.fastbank',
      //       img: FastBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.acbabank',
      //       img: AcbaBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.armeconombank',
      //       img: AEBLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.ameriabank',
      //       img: AmeriaBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     },
      //     {
      //       name: 'providers.idbank',
      //       img: IDBankLogo,
      //       commission: ['categories.commission.commission300AMD'],
      //       period: 'categories.transferPeriod.instantly',
      //       available: ['wallet'],
      //       maxSum: '100 - 100,000'
      //     }
      //   ]
      // }
    ]
  },
  {
    id: 'government',
    title: 'categories.options.government.short',
    types: [
      {
        name: 'categories.options.government.types.property',
        icon: <PropertyIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.property',
            img: null,
            commission: ['categories.commission.commissionProperty'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '1 - 999.999'
          }
        ]
      },
      {
        name: 'categories.options.government.types.garbage',
        icon: <GarbageIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.garbage',
            img: null,
            commission: ['categories.commission.commissionGarbage'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '1 - 999.999'
          }
        ]
      }
    ]
  },
  {
    id: 'fines',
    title: 'categories.options.fines.short',
    types: [
      {
        name: 'categories.options.fines.types.parking',
        icon: <ParkingIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.parking',
            img: null,
            commission: ['categories.commission.commissionParking'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches', 'wallet'],
            maxSum: '100 - 160.000'
          }
        ]
      },
      {
        name: 'categories.options.fines.types.parkingFine',
        icon: <CarIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.parkingFine',
            img: null,
            commission: ['categories.commission.commission300AMD'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches'],
            maxSum: '100 - 160.000'
          }
        ]
      },
      {
        name: 'categories.options.fines.types.roadPoliceCamera',
        icon: <CameraIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.roadCameraFine',
            img: null,
            commission: ['categories.commission.commissionRoadCameraFine'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches'],
            maxSum: '100 - 390.000'
          }
        ]
      },
      {
        name: 'categories.options.fines.types.roadPoliceFine',
        icon: <PolicemanIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.policemanFine',
            img: null,
            commission: ['categories.commission.commissionPoliceFine'],
            period: 'categories.transferPeriod.instantly',
            available: ['branches'],
            maxSum: '100 - 390.000'
          }
        ]
      },
      {
        name: 'categories.options.fines.types.games',
        icon: <GamepadIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.warface',
            img: WarfaceLogo,
            commission: ['categories.commission.commission309Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '400 - 96,993'
          },
          {
            name: 'providers.steam',
            img: SteamLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '200 - 100,000'
          },
          {
            name: 'providers.heroesWm',
            img: HeroesWmLogo,
            commission: ['categories.commission.commission416Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 96,006'
          },
          {
            name: 'providers.crossout',
            img: CrossoutLogo,
            commission: ['categories.commission.commission416Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 96,006'
          }
        ]
      },
      {
        name: 'categories.options.fines.types.other',
        icon: <ServicesIcon size="20px" className="text-primary-500" />,
        providers: [
          {
            name: 'providers.globbing',
            img: GlobbingLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.globbingCustoms',
            img: GlobbingLogo,
            commission: ['categories.commission.commissionGlobbingCustoms'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 999,600'
          },
          {
            name: 'providers.onex',
            img: OnexLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.glovo',
            img: GlovoLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.mimoBike',
            img: MimoBikeLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.yerevanRide',
            img: YerevanRideLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.emexRu',
            img: EmexRuLogo,
            commission: ['categories.commission.commissionZero'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 100,000'
          },
          {
            name: 'providers.odnoklassniki',
            img: OdnoklassnikiLogo,
            commission: ['categories.commission.commission416Percent'],
            period: 'categories.transferPeriod.instantly',
            available: ['wallet'],
            maxSum: '100 - 96,006'
          }
        ]
      }
    ]
  }
]
